<app-page-header Heading="{{ userProfile.firstName + ' ' + userProfile.lastName }}" Description="">
  <app-back-button headerPrefix></app-back-button>
  <!-- <div class="btn btn-sm btn-primary">Add Company</div> -->
</app-page-header>

<div class="row">
  <!-- User Card - Left Side -->
  <div class="col-lg-2">
    <div class="organizationdetailcard">
      <div class="overviewHead position-relative">
        <img src="/assets/images/company-background.jpg" alt="" class="w-100 cardImg" />
        <div class="organizationImg">
          <ng-container *ngIf="userProfile.profileImage; else defaultImage">
            <img [src]="userProfile.profileImage" class="profile-img" alt="Profile Image" />
          </ng-container>
          <ng-template #defaultImage>
            <img src="../../../assets/images/icons/userProfilePhoto.png" class="profile-img" alt="Default User Image" />
            <!--veryicon.com-->
          </ng-template>

          <div class="image-overlay">
            <!-- View icon -->
            <i class="bi bi-eye edit-icon me-2" (click)="
                viewImage(
                  userProfile.profileImage ||
                    'assets/images/icons/userProfilePhoto.png'
                )
              "></i>

            <!-- Pencil icon -->
            <i class="bi bi-pencil-square edit-icon" (click)="fileInput.click()"></i>
          </div>

          <input #fileInput type="file" accept="image/*" style="display: none" (change)="onFileSelected($event)" />
        </div>
      </div>

      <!-- Image Preview Container - Right Side -->
      <div class="image-preview-container" *ngIf="showImageModal">
        <div class="image-preview-box">
          <img [src]="selectedImage" alt="Preview" class="preview-image" />
          <button type="button" class="btn btn-sm btn-danger close-btn" (click)="closeImageModal()">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </div>

      <div class="px-3 py-2 mt-5">
        <h6 class="labelFont">
          {{ userProfile.firstName }} {{ userProfile.lastName }}
        </h6>
        <p>{{ userProfile.designation }}</p>
      </div>

      <div class="px-3 py-2">
        <ng-container *ngFor="let role of userRoleList">
          <span class="badge bg-success px-1 py-1" style="margin-right: 2px">{{
            role.roleName
            }}</span>
        </ng-container>
      </div>

      <div class="px-3 py-2">
        <h6 class="labelFont">Contact Details :</h6>
        <p>
          <i class="bi bi-telephone" style="color: var(--bs-primary)"></i>
          {{ userProfile.mobileNo }}
        </p>
        <p>
          <i class="bi bi-envelope" style="color: var(--bs-primary)"></i>
          {{ userProfile.emailId }}
        </p>
      </div>
    </div>
  </div>

  <!-- Accordion Content - Right Side -->
  <div class="col-lg-10">
    <div class="accordion" id="accordionExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
            aria-expanded="true" aria-controls="collapseOne">
            <h6 class="labelFont">Profile</h6>
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <form [formGroup]="editUserForm">
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label">First name</label>
                  <input type="text" class="form-control" formControlName="firstName" [readonly]="!isEditMode" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Middle name</label>
                  <input type="text" class="form-control" formControlName="middleName" [readonly]="!isEditMode" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Last name</label>
                  <input type="text" class="form-control" formControlName="lastName" [readonly]="!isEditMode" />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <label class="form-label">Username</label>
                  <input type="text" class="form-control"  [value]="userProfile.emailId" disabled />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Date of birth</label>
                  <input type="date" class="form-control" formControlName="dob" [readonly]="!isEditMode" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Designation</label>
                  <input type="text" class="form-control" formControlName="designation" [readonly]="!isEditMode" />
                </div>
              </div>
            </form>

            <div class="row mb-3">
              <div class="col-12 d-flex justify-content-end gap-2 mt-3">
                <button class="btn btn-warning btn-sm" (click)="openResetPasswordModal()">
                  Reset Password
                </button>

                <ng-container *ngIf="!isEditMode; else editModeButtons">
                  <button class="btn btn-primary btn-sm" (click)="enterEditMode()">
                    Edit
                  </button>
                </ng-container>

                <ng-template #editModeButtons>
                  <button class="btn btn-success btn-sm" (click)="updateUser()">
                    Save
                  </button>
                  <button class="btn btn-secondary btn-sm" (click)="cancelEdit()">
                    Cancel
                  </button>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Details -->
<!-- Contact Details -->
<div class="accordion-item">
  <h2 class="accordion-header">
    <button
      class="accordion-button collapsed"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseTwo"
      aria-expanded="false"
      aria-controls="collapseTwo"
    >
      <h6 class="labelFont">Contact Details</h6>
    </button>
  </h2>
  <div
    id="collapseTwo"
    class="accordion-collapse collapse"
    data-bs-parent="#accordionExample"
  >
    <div class="accordion-body">
      <!-- Wrap contact details in the same form -->
      <form [formGroup]="editUserForm">
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label">Email address</label>
            <input
              type="email"
              class="form-control"
              formControlName="emailId"
             [readonly]="!isEditMode"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label">Phone number</label>
            <input
              type="tel"
              class="form-control"
              formControlName="mobileNo"
              [readonly]="!isEditMode"
            />
          </div>
        </div>
      </form>

      <div class="row mb-3">
        <div class="col-12 d-flex justify-content-end gap-2 mt-3">
          <ng-container *ngIf="!isEditMode; else editModeButtons">
            <button
              class="btn btn-primary btn-sm"
              (click)="enterEditMode()"
            >
              Edit
            </button>
          </ng-container>

          <ng-template #editModeButtons>
            <button class="btn btn-success btn-sm" (click)="updateUser()">
              Save
            </button>
            <button
              class="btn btn-secondary btn-sm"
              (click)="cancelEdit()"
            >
              Cancel
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

    <!-- Roles Details -->
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
          <h6 class="labelFont">Roles Details</h6>
        </button>
      </h2>
      <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <div class="row mb-3">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
              <!-- Left Side: User Roles -->
              <div>
                <ng-container *ngIf="userRoleList && userRoleList.length > 0; else noRoles">
                  <span *ngFor="let role of userRoleList" class="badge bg-success px-2 py-2"
                    style="font-size: 1rem; margin-right: 5px">
                    {{ role.roleName }}&nbsp;
                    <i class="fa fa-minus-square" style="color: red; cursor: pointer"
                      (click)="deleteUserRole(role)"></i>
                  </span>
                </ng-container>
                <ng-template #noRoles>
                  <p style="color: red">No Roles Assigned</p>
                </ng-template>
              </div>

              <!-- Right Side: Add Role Button -->
              <ng-container *ngIf="!isAssigningRole">
                <button class="btn btn-primary btn-sm" (click)="assignRole()">
                  <i class="bi bi-plus"></i> Assign New Role
                </button>
              </ng-container>

              <!-- Role Selection Dropdown + Add Button -->
              <ng-container *ngIf="isAssigningRole">
                <div class="d-flex">
                  <select class="form-select" [(ngModel)]="userRoleCreate.roleId">
                    <ng-container *ngIf="filteredRoleList.length > 0; else NoRolesFound">
                      <option [ngValue]="0" disabled>Select Role</option>
                      <option *ngFor="let role of filteredRoleList" [ngValue]="+role.key">
                        {{ role.value }}
                      </option>
                    </ng-container>

                    <ng-template #NoRolesFound>
                      <option [value]="0" disabled>Select Role</option>
                      <option disabled disabled style="color: red">
                        No roles found
                      </option>
                    </ng-template>
                  </select>

                  <button class="btn btn-success btn-sm ms-2" (click)="addRole()">
                    +
                  </button>
                  <button class="btn btn-danger btn-sm ms-2" (click)="isAssigningRole = false">
                    x
                  </button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Branch Details -->
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
          <h6 class="labelFont">Branch Details</h6>
        </button>
      </h2>
      <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <div class="row mb-3">
            <div class="col-md-12">
              <ng-container *ngIf="userBranch && userBranch.length > 0; else noBranches">
                <span *ngFor="let branch of userBranch" class="badge bg-success px-2 py-2"
                  style="font-size: 1rem; margin-right: 5px">
                  {{ branch.branchName }}&nbsp;
                </span>
              </ng-container>
              <ng-template #noBranches>
                <p style="color: red">No Branch Assigned</p>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #resetPasswordModalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Reset Password</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="resetPasswordModal.close()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="resetPasswordForm">
      <div class="mb-3">
        <label class="form-label">New Password</label>
        <input type="password" class="form-control" formControlName="userPassword" placeholder="Enter new password" />
        <app-form-errors [control]="resetPasswordForm.get('userPassword')" fieldName="New Password"></app-form-errors>
      </div>

      <div class="mb-3">
        <label class="form-label">Confirm Password</label>
        <input type="password" class="form-control" formControlName="confirmPassword" placeholder="Confirm password" />
        <app-form-errors [control]="resetPasswordForm.get('confirmPassword')"
          fieldName="Confirm Password"></app-form-errors>
        <small *ngIf="resetPasswordForm.errors?.['passwordMismatch'] && resetPasswordForm.touched">
          <small class="text-danger">Passwords do not match.</small>
        </small>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm" (click)="resetUserPassword()">
      Submit
    </button>
    <button type="button" class="btn btn-secondary btn-sm" (click)="resetPasswordModal.close()">
      Cancel
    </button>
  </div>
</ng-template>